export enum TipoImpresion {
    GLOBAL = 'GLOBAL',
    ESCPOS = 'ESCPOS',
    PDF = 'PDF',
    TEXT = 'TEXT',
}
